import { render, staticRenderFns } from "./MerchantUserManageDetail.vue?vue&type=template&id=678f7270&scoped=true"
import script from "./MerchantUserManageDetail.vue?vue&type=script&lang=js"
export * from "./MerchantUserManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678f7270",
  null
  
)

export default component.exports